import { useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../../contexts/AuthenticationContext';
import Loading from '../../components/common/Loading';

export interface AuthorizeProps {
    history: unknown;
    location: object;
    match: unknown;
    staticContext: unknown;
}

export const Authorize = () => {
    const navigate = useNavigate();
    const { signedOn, isAuthenticated } = useContext(AuthContext);
    const redirectUrl = sessionStorage.getItem('after_redirect') ?? '/';

    useEffect(() => {
        signedOn(window.location.hash);
    }, [signedOn]);

    useEffect(() => {
        if (isAuthenticated()) {
            navigate(redirectUrl);
        }
    }, [isAuthenticated, navigate, redirectUrl]);

    return <Loading />;
};

export default Authorize;
